import {ISortingState} from 'plugins/modules/sorting/types';
import {PayloadAction} from '@reduxjs/toolkit';

export function createSortingActions<T extends ISortingState>() {
    return {
        actionSetSortingList(state: T, {payload}: PayloadAction<T['sortingList']>) {
            state.sortingList = payload;
        },
    };
}
